import initMainmenu from './modules/mainmenu/initMainmenu'

initMainmenu(
  document.getElementById('mainmenu'),
  document.getElementById('mainmenu-desktop')
)
